"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports.darkTheme = exports.lightTheme = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Dimensions = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Dimensions"));

var _breakpoints = require("./breakpoints");

var _colors = require("./colors");

var _radii = require("./radii");

var _spacings = require("./spacings");

var _typography = require("./typography");

var _helpers = require("../helpers");

var _responsiveStyle = require("../helpers/responsiveStyle");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var themeBase = {
  breakpoints: _breakpoints.breakpointsDefault,
  radii: _radii.radiiDefault,
  spacings: _spacings.spacingsDefault,
  typography: _typography.typographyDefault,
  responsiveStyle: _responsiveStyle.responsiveStyle,
  responsiveValue: _responsiveStyle.responsiveValue,
  width: _Dimensions["default"].get("window").width,
  height: _Dimensions["default"].get("window").height,
  breakpoint: (0, _helpers.getBreakpoint)(_Dimensions["default"].get("window").width, _breakpoints.breakpointsDefault)
};

var lightTheme = _objectSpread({
  name: "lightTheme",
  colors: _colors.colorsLightTheme
}, themeBase);

exports.lightTheme = lightTheme;

var darkTheme = _objectSpread({
  name: "darkTheme",
  colors: _colors.colorsDarkTheme
}, themeBase);

exports.darkTheme = darkTheme;
var themes = {
  lightTheme: lightTheme,
  darkTheme: darkTheme
};
exports.themes = themes;